<!-- 通知详情 -->
<template>
  <div id="newsDetail">
    <headerVue></headerVue>
    <div class="container">
      <div class="inner">
        <h2>{{ this.articleInfo.title }}</h2>
        <div class="smallTitle">
          <span>发布日期：{{
            this.articleInfo.createTime.substr(
              0,
              this.articleInfo.createTime.length - 9
            )
            }}</span>
        </div>
        <!-- 文章内容 -->
        <div class="content">
          <!-- <p v-html="this.articleInfo.content"></p> -->
          <div style="width: 100%;line-height: 1.75" class="ql-snow ql-editor"
            v-html="$options.filters.safeHtmlContent(this.articleInfo.content)"></div>
        </div>
      </div>
    </div>
    <footerVue></footerVue>
  </div>
</template>

<script>
import Vue from 'vue'
import headerVue from "../index/header.vue";
import footerVue from "../foot/foot.vue";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

// Vue.filter('formatter', function (value) {
//   // 只给 p 标签加首行缩进的样式
//   return value.replace(/<p>/g, '<p style="text-indent: 20px;">');
// });

export default {
  name: "noticeDetail",
  data() {
    return {
      articleInfo: {
        title: "",
        createTime: "",
        content: "",
      },
    };
  },
  filters: {
    safeHtmlContent(val) {
      // return val.replace(/<p>/g, '<p style="text-indent: 30px; !importent">');
      return val.replace(/<p>/g, '<p style="text-indent: 2em;text-align:justify;font-size: 16px;">');
    }
  },
  // computed: {
  //   safeHtmlContent() {
  //     // 在这里应用过滤器
  //     return this.$options.filters.formatter(this.articleInfo.content);
  //   }
  // },
  created() {
    this.getArticleDetail();
  },
  updated() {
    // 处理 v-html 解析富文本中有图片的情况
    // let DomList = document
    //   .getElementsByClassName("content")[0]
    //   .querySelectorAll("img");
    // console.log(DomList);
    // for (let i in DomList) {
    //   if (DomList[i].style) {
    //     console.log(DomList[i].src);
    //     if (DomList[i].src.indexOf("/prod-api/profile") != -1) {
    //     } else {
    //       DomList[i].src =
    //         DomList[i].src.substr(0, 33) +
    //         "prod-api/profile/" +
    //         DomList[i].src.substr(33);
    //     }
    //     console.log(DomList[i].src);
    //     DomList[i].style.width = "100%";
    //   }
    // }
  },

  methods: {
    // -------  替换图片链接 --------start
    replaceImg(a) {
      // a 为富文本的字符串内容，为了测试，只写了img标签
      var b = /< img [^>]*src=['"]([^'"]+)[^>]*>/g; // img 标签取src里面内容的正则
      var s = a.match(b); // 取到所有img标签 放到数组 s里面
      if (s) {
        for (var i = 0; i < s.length; i++) {
          var srcImg = s[i].replace(b, '$1'); //取src面的内容
          // 这里用来拼接
          var baseUrl = '/prod-api/profile';
          if (srcImg != '' && srcImg != undefined) {
            if (srcImg.startsWith('/prod-api/profile')) {
              // console.log('富文本图片路径以/prod-api/profile开头');

            } else {
              // console.log('富文本图片路径不以/prod-api/profile开头');
              //修改富文本字符串内容 img标签src 相对路径改为绝对路径
              a = a.replace(/src=['"]([^'"]+)[^>]*>/gi, 'src="' + baseUrl + srcImg + '"' + '>');
              // console.log(srcImg);
            }
          }
        }
      }
      return a
    },
    // -------  替换图片链接 --------end
    // 获取新闻详情信息
    async getArticleDetail() {
      // console.log('nnnnnnnnnnnnnnnnnid', this.$route.query.tm);
      let res = await this.$api.nav.getNoticedesc(this.$route.query.tm);
      // console.log('1111', res);
      this.articleInfo.title = res.data.data.title;
      this.articleInfo.createTime = res.data.data.createTime;
      this.articleInfo.content = res.data.data.content;
      // console.log(this.articleInfo);

      // ------- 处理富文本图片信息 start
      // 匹配图片URL的正则表达式
      const imageRegex = /<img.*?src="(.*?)".*?>/g;

      // 替换图片URL
      // const replacedArticleContent = this.articleInfo.articleContent.replace(imageRegex, (match, url) => {
      //   return `<p align="center"><img src="${this.processUrl(url)}" alt="Image"></p>`;
      // });

      const replacedArticleContent = this.replaceImg(this.articleInfo.articleContent)

      // console.log('---替换图片后内容');
      // console.log(replacedArticleContent);
      this.articleInfo.articleContent = replacedArticleContent;
      //------- 处理富文本图片信息 end
    },
  },
  components: {
    headerVue,
    footerVue,
  },
};
</script>

<style lang="scss">
.ql-lineheight-5 {
  line-height: 5;
}

ql-lineheight-1-5 {
  line-height: 1.5;
}

ql-lineheight-1-75 {
  line-height: 1.75;
}

ql-lineheight-2 {
  line-height: 2;
}

ql-lineheight-3 {
  line-height: 3;
}

ql-lineheight-4 {
  line-height: 4;
}

ql-lineheight-5 {
  line-height: 5;
}

#newsDetail {
  background-color: #f5f5f5;
}

.container {
  background-color: white !important;
  padding: 10px 0px;
  margin-top: 20px;
  width: 1200px;
  margin-left: auto;
  margin-right: auto;

  .inner {
    padding: 40px 80px;

    h2 {
      font-size: 26px;
      color: #222222;
      font-weight: bold;
      line-height: 38px;
      margin-bottom: 15px;
      text-align: center;
    }

    .smallTitle {
      font-size: 14px;
      color: #666666;
      line-height: 24px;
      margin: 0 10px;
      text-align: center;
      padding-bottom: 55px;
      border-bottom: 1px solid #e9e9e9;

      span {
        margin-right: 30px;
      }
    }

    .content {
      margin-top: 30px;
    }
  }
}
</style>